export { default as GalleryFeed } from './GalleryFeed'
export { default as StyledGalleryFeed } from './GalleryFeed.Styled'

export { GalleryFeedSortable } from './GalleryFeedSortable'
export { default as StyledGalleryFeedSortable } from './GalleryFeedSortable.Styled'

export { default as useGalleryFeed } from '../../../redux/gallery/useGalleryFeed'
